import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { Paper, Typography } from '@mui/material';

import { CANCEL_CONTRACT, GET_CANCELLATION_PAGE_DATA, GET_CUSTOMER } from '../../../shared';

import LandingPageContents from './LandingPageContents';
import { BackButton, PageTitle } from '../../../components/common';
import { StyledDesktopImage, StyledMobileImage, StyledImageContainer } from './LandingPage.styled';

export default function LandingPage({ pageTitleId, pageDesktopImage, pageMobileImage, paper }) {
  const history = useHistory();

  const [disableButton, setDisableButton] = useState(false);

  const { data } = useQuery(GET_CANCELLATION_PAGE_DATA, {
    fetchPolicy: 'network-only',
  });
  const cancellationPageKey = data?.cancellationPageData?.key;

  const [cancelContract] = useMutation(CANCEL_CONTRACT, {
    refetchQueries: [{ query: GET_CUSTOMER }],
  });

  const handleExit = () => history.goBack();

  const handleCancelContract = async () => {
    setDisableButton(true);
    const response = await cancelContract();

    if (response?.data?.cancelContract?.status === 'success') {
      history.replace('/cancellation-reason');
    } else {
      history.replace('/contract-cancellation/fail');
    }
    setDisableButton(false);
  };

  return (
    <>
      <BackButton onClick={() => history.goBack()}>
        <FormattedMessage id="common.button.back" />
      </BackButton>

      <PageTitle>
        <Typography variant="h1">
          <FormattedMessage id={pageTitleId} />
        </Typography>
      </PageTitle>

      <StyledImageContainer>
        <StyledMobileImage src={pageMobileImage} alt="" />
        <StyledDesktopImage src={pageDesktopImage} alt="" />
      </StyledImageContainer>

      <Paper elevation={paper ? 1 : 0} transparent={!paper}>
        <LandingPageContents
          cancellationPageKey={cancellationPageKey}
          handleExit={handleExit}
          handleCancelContract={handleCancelContract}
          disableButton={disableButton}
        />
      </Paper>
    </>
  );
}
